const Video = (videoType, videoPath, defer = false, autoplay = false) => ({
  /**
   * Type of the video, e.g. 'file' or 'youtube'
   */
  videoType: videoType,

  /**
   * Either the file path, or the YouTube ID
   */
  videoPath: videoPath,

  /**
   * Whether the player should automatically start playback
   */
  autoplay: autoplay,

  /**
   * Whether the player code is embedded into the website
   */
  isEmbedded: false,

  hasPoster() {
    return this.$root.classList.contains('video--has-poster');
  },

  async embedVideo(autoplay) {
    this.autoplay = autoplay;
    this.isEmbedded = true;

    await this.$nextTick();

    window.Cookiebot.runScripts();
  },

  stopVideo() {
    this.isEmbedded = false;
  },

  onClickPlay() {
    window.dispatchEvent(new CustomEvent('Videos.stopAllVideos'));

    window.addEventListener('Videos.stopAllVideos', () => {
      this.stopVideo();
    });

    this.embedVideo(true);
  },

  onIntersect() {
    if (defer) {
      this.embedVideo(this.autoplay);
    }
  },

  init() {
    if (!defer && !this.hasPoster()) {
      this.embedVideo(this.autoplay);
    }
  }
});

export default Video;
